import { render, staticRenderFns } from "./team-members-editor.vue?vue&type=template&id=0f70e60c&"
import script from "./team-members-editor.vue?vue&type=script&lang=js&"
export * from "./team-members-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports